import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <svg viewBox="0 0 32 32" fill="none">
                <path d="M16 4L28 10V22L16 28L4 22V10L16 4Z" stroke="url(#footer-gradient)" strokeWidth="2" fill="none"/>
                <path d="M16 12L22 15V21L16 24L10 21V15L16 12Z" fill="url(#footer-gradient)"/>
                <defs>
                  <linearGradient id="footer-gradient" x1="4" y1="4" x2="28" y2="28">
                    <stop stopColor="#667eea"/>
                    <stop offset="1" stopColor="#764ba2"/>
                  </linearGradient>
                </defs>
              </svg>
              <span>Trackable</span>
            </div>
            <p>AI-powered fitness coaching that knows you.</p>
          </div>
          
          <div className="footer-links">
            <div className="footer-column">
              <h4>Product</h4>
              <a href="#features">Features</a>
              <a href="#ai-coach">AI Coach</a>
              <a href="#why-trackable">Why Trackable</a>
            </div>
            <div className="footer-column">
              <h4>Company</h4>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
              <a href="mailto:support@trackable.fit">Contact</a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>2025 Trackable. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
